/**
 * Quiz streak detection.
 * Ported from quebon-student-web utils/utils.js::isConsecutiveThree
 * with an added boolean guard against null entries.
 */

export type StreakEntry = boolean | null

/**
 * Returns true iff arr[currentIndex] forms a streak of EXACTLY three identical
 * boolean values ending at currentIndex. A streak of four or more does NOT
 * count (combo fires only on the 3rd consecutive same result).
 */
export function isConsecutiveThree(arr: StreakEntry[], currentIndex: number): boolean {
  if (currentIndex < 2 || arr.length < 3) return false

  const cur = arr[currentIndex]
  if (typeof cur !== 'boolean') return false

  if (arr[currentIndex - 1] !== cur) return false
  if (arr[currentIndex - 2] !== cur) return false

  // Disqualify if the run extends back 4 or more.
  let count = 0
  for (let i = currentIndex; i >= 0; i--) {
    if (arr[i] === cur) count++
    else break
  }
  return count === 3
}
